import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/auth/login.service';
import { ApiService } from 'src/app/Services/api.service';
import { MediaService } from 'src/app/Services/media.service';
import { Busyable } from 'src/app/shared/editors/busyable';

@Component({
    selector: 'app-calendardaytype',
    templateUrl: './calendardaytype.component.html',
    styleUrls: ['./calendardaytype.component.scss'],
    standalone: false
})

export class CalendarDayTypeComponent extends Busyable implements OnInit {
  public ModelId : any;
  public Model: any;

  constructor(mediaService: MediaService, private loginService: LoginService, private apiService: ApiService, private parentRoute: ActivatedRoute) {
      super();
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params.subscribe(params => { this.ModelId = params['id']; });
    this.apiService.Get<any>("calendar/daytypes/" + this.ModelId).then(result => {
        this.Model = result;
        this.StopLoading();
    });
  }
}
